import Enums from 'utils/EnumsManager';

const { OBJECTLIST } = Enums.REDUX_ACTION_TYPE_PREFIX;
export const SET_DATA = `${OBJECTLIST}SET_DATA`;
export const SET_ROW_SELECTION = `${OBJECTLIST}SET_ROW_SELECTION`;
export const SET_OPTIONS = `${OBJECTLIST}SET_OPTIONS`;
export const SET_VIEWS = `${OBJECTLIST}SET_VIEWS`;
export const SET_ACTIVE_VIEW = `${OBJECTLIST}SET_ACTIVE_VIEW`;
export const SET_PAGE_SIZE = `${OBJECTLIST}SET_PAGE_SIZE`;
export const SET_SORTER = `${OBJECTLIST}SET_SORTER`;
export const DELETE_SORTER_BY_VIEW = `${OBJECTLIST}DELETE_SORTER_BY_VIEW`;
export const SET_PAGINATION_STATUS = `${OBJECTLIST}SET_PAGINATION_STATUS`;
export const RESET_COLUMNS = `${OBJECTLIST}RESET_COLUMNS`;
export const RESET_COLUMNS_AND_DATA = `${OBJECTLIST}RESET_COLUMNS_AND_DATA`;



// WEBPACK FOOTER //
// ./src/views/ObjectList/flow/actionTypes.js